export default function MemberMenuCtrl($scope, $rootScope, $log, $state, $timeout, $location, menu, acknowledge, $wamp, $mdDialog) {
  var vm = this;

  vm.sections = [];
  vm.isOpen = isOpen;
  vm.toggleOpen = toggleOpen;
  vm.autoFocusContent = false;

  menu.sections
      .distinctUntilChanged()
      .safeApply($scope, function (sections) {

        vm.sections = sections;

        //Make sure the right menu is opened if a page is page within a
        // section is selected on refresh
        sections
            .filter(function (section) {
              return section.type === "toggle";
            })
            .filter(function (section) {
              return section.pages
                  .filter(function (page) {
                    var name = page.state.split('(')[0];
                    return $state.is(name);
                  })
                  .reduce(function (p, c) {
                    return true;
                  }, false);
            })
            .forEach(function (section) {
              toggleOpen(section);
            });
      })
      .subscribe();

  vm.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };

  function isOpen(section) {
    return menu.isSectionSelected(section);
  }

  function toggleOpen(section) {
    menu.toggleSelectSection(section);
  }

  acknowledge
      .subscribe(function (messages) {
        //todo change the state for the dialog
        var message = messages.shift();

        if (!message) {
          $mdDialog.hide();
          return;
        }

        var toState = JSON.parse(JSON.stringify($state.current));//copy the
                                                                 // state
        var toParams = $state.params;
        toState.href = message.title;
        $wamp.call('org.eggs.state_change', [toState, toParams]);

        var dialog = $mdDialog.alert()
        // .parent(angular.element(document.querySelector('html')))
            .clickOutsideToClose(false)
            .escapeToClose(false)
            .title(message.title)
            .textContent(message.text)
            .ok(message.submit_message);

        $mdDialog.show(dialog).then(
            function () {
              //Make RPC to ack the message
              $wamp.call('org.eggs.ack_acknowledgement', [message.id]);
              var toParams = $state.params;
              $wamp.call('org.eggs.state_change', [$state.current, toParams]);
            },
            function () {
              //handle errors
            });
      });
}
